<template>
    <div class="gig-review">
        <post-success-call-to-action
            heading="Kiitos arvostelustasi!"
            message="Arvostelusi on nyt lähetetty artistille ja lisätty artistin profiiliin."
            v-if="formState=='sent'"
        ></post-success-call-to-action>
        <form v-if="formState!='sent'" v-on:submit.prevent="sendReview" method="post" name="send-review" class="default" accept-charset="UTF-8">
            <div class="row">
                <div class="col-md-12">
                    <h3>{{ subject }}</h3>
                    <div class="form-group" :class="{ 'form-group--error': $v.points.$error }">
                        <label class="mb-3">Miten keikka mielestäsi meni?</label>
                        <radio-group
                            :items=pointsOptions
                            name="points"
                            v-model="points"
                        >
                        </radio-group>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group" :class="{ 'form-group--error': $v.message.$error }">
                        <label>Vapaa palaute keikasta</label>
                        <textarea
                            rows="4"
                            v-model="$v.message.$model"
                            id="message"
                            @focusin="removeMessagePlaceholder"
                            @focusout="addMessagePlaceholder"
                        ></textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 text-center mt-4">
                    <button type="submit" class="btn btn--call-to-action">
                        Lähetä arvostelu
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import { required, minLength } from 'vuelidate/lib/validators';
    import FormData from '../modules/FormData';
    import Messages from '../modules/Messages';
    import Routes from '../modules/Routes';
    import RadioGroup from './RadioGroup';
    import PostSuccessCallToAction from './PostSuccessCallToAction';

    export default {
        components: {
            RadioGroup,
            PostSuccessCallToAction
        },
        model: {
            prop: 'points',
            event: 'change'
        },
        props: {
            subject: {
                type: String,
                required: true
            },
            gigChecksum: {
                type: String,
                required: true
            },
            gigId: {
                type: String,
                required: true
            },
            initialMessage: {
                type: String,
                default: 'Kerro vapaasti palautteesi keikasta'
            },
            initialPoints: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            pointsOptions: {
                type: Array,
                default: () => {
                    return [
                        { id: 1, name: 'Surkea' },
                        { id: 2, name: 'Vähän sinne päin' },
                        { id: 3, name: 'Ihan ok' },
                        { id: 4, name: 'Erittäin hyvä' },
                        { id: 5, name: 'Paras ikään' }
                    ];
                }
            }
        },
        data() {
            return {
                points: this.initialPoints,
                message: this.initialMessage,
                formState: 'not-sent'
            };
        },
        validations: {
            points: {
                required
            },
            message: {
                required,
                minLength: minLength(10)
            }
        },
        methods: {
            sendReview() {
                if (this.$v.$invalid) {
                    Messages.error('Tarkista, että käytit kaikki tiedot');
                    return;
                }
                if (this.message === this.initialMessage) {
                    Messages.error('Kerrothan bändille myös muutamalla sanalla, miten keikka meni');
                    return;
                }
                let formData = new FormData(this.$data);
                this.$http.post(this.getUrl(), JSON.stringify(formData.parseGigReviewData(this)), {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    Messages.successFromResponse(response);
                    this.formState = 'sent';
                    this.$ga.event('Gig review', 'Sent successfully');
                    gtag('event', 'send_gig_review', { gig_id: this.gigId });
                }, (response) => {
                    Messages.errorFromResponse(response);
                    this.$ga.event('Gig review', 'Sending failed');
                });
            },
            getUrl() {
                return Routes.generate('_public_api_send_gig_review', { id: this.gigId, hash: this.gigChecksum });
            },
            removeMessagePlaceholder() {
                if (this.message === this.initialMessage) {
                    this.message = ' ';
                }
            },
            addMessagePlaceholder() {
                if (!this.message || /^\s*$/.test(this.message)) {
                    this.message = this.initialMessage;
                }
            }
        }
    };
</script>
